import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

const getTimeDisplay = totalSeconds => {
  if (totalSeconds <= 0) return '00:00';

  const durationTime = dayjs.duration(totalSeconds, 'seconds');
  const minutes = Math.floor(durationTime.asMinutes()).toString().padStart(2, '0');
  const seconds = durationTime.seconds().toString().padStart(2, '0');

  return `${minutes}:${seconds}`;
};

const useExpirationCountdown = ({ expirationCountdown, expiredAt, onExpire }) => {
  const initialTimeLeft = expirationCountdown * 1000;
  const expiredRef = useRef(false);
  const [timeLeft, setTimeLeft] = useState(() =>
    Math.max(0, Math.min(expiredAt - Date.now(), initialTimeLeft)),
  );

  useEffect(() => {
    expiredRef.current = false;
    const updateTimeLeft = () => {
      const remaining = expiredAt - Date.now();
      setTimeLeft(Math.max(0, remaining));

      if (remaining <= 0 && !expiredRef.current) {
        expiredRef.current = true;
        onExpire();
      }
    };

    const timer = setInterval(updateTimeLeft, 50);
    updateTimeLeft();

    return () => clearInterval(timer);
  }, [expiredAt, onExpire]);

  const isExpired = timeLeft <= 0;
  const remainingSeconds = Math.max(0, Math.ceil(timeLeft / 1000));
  const timeDisplay = getTimeDisplay(remainingSeconds);
  const timerProgress = Math.min(1, remainingSeconds / expirationCountdown);

  return { isExpired, timeDisplay, timerProgress };
};

export default useExpirationCountdown;
